'use strict';

import {reverseUrl} from 'utils/django';

import './style.css';
import modalDirective from '../../rest-modal';
import template from './template.html';


export default modalDirective({
	template: template,
	resolve: {
		users: resolveActiveUsersForIncident,
	}
});


function resolveActiveUsersForIncident($incident, $http, $context) {
	'ngInject';

	var url = reverseUrl('entities:entity');
	return $http.get(url).then(function(response) {
		var users = [];
		var teamUUIDs = $incident.team.map(function(incidentUser) {
			return incidentUser.user.uuid;
		});
		for (let role of response.data.roles) {
			if ($context.roles.indexOf(role.display_name) == -1) {
				continue;
			}
			for (let user of role.users) {
				if (!user.is_active || !user.is_available) {
					continue;
				}
				if (teamUUIDs.indexOf(user.uuid) == -1) {
					user.role = role.display_name;
					users.push(user);
				}
			}
		}
		return users;
	});
}
